export const formdata = [
  {
    id: 1,
    formid: "contactform",
    formname: "Acrylic Web Studios Contact Form",
    sect1fields: ["Name", "Email", "Message"],
    name: "",
    btntext: "Let’s go!",
    btnicon: "material-symbols:rocket-launch-outline",
    success:
      "Your message has been sent! We will be in touch as soon as possible.",
  },

  {
    formtitle: "Let's get things rolling",
    formintro:
      "At Acrylic Web Studios, every great website starts with understanding your vision. This short form helps us learn more about your organisation, your goals, and the functionality you need. The more detail you share, the better we can design a site that truly represents your brand and drives results.",
    id: 2,
    formid: "initialform",
    formname: "Acrylic Web Studios Initial Form",
    sect1header: "Introduction",
    sect1fields: [
      "Name",
      "Email",
      "OrganisationName",
      "Reason",
      "ExistingSite",
      "Audience",
    ],
    sect2header: "About Your Organisation",
    sect2fields: ["Organisation", "Unique", "Branding"],
    sect3header: "Functionality",
    sect3fields: ["Functionality", "Features", "Inspiration", "Success"],
    btntext: "Let’s go!",
    btnicon: "material-symbols:rocket-launch-outline",
    success:
      "Your information has been sent! We will be in touch with next steps as soon as possible.",
  },

  {
    id: 3,
    formname: "client-intake",
    formid: "clientintake",
    formtitle: "New Client Website Questionnaire",
    formintro:
      "Please provide as much detail as possible so we can create a website tailored to your business.",
    sect1header: "Business Overview",
    sect1fields: [
      "businessName",
      "businessTagline",
      "businessDescription",
      "productsServices",
      "targetAudience",
      "uniqueSellingPoints",
      "brandAssets",
    ],
    sect2header: "Website Goals & Strategy",
    sect2fields: [
      "websitePrimaryGoal",
      "visitorActions",
      "businessGoals",
      "competitorInspiration",
      "preferredTone",
    ],
    sect3header: "Website Content",
    sect3fields: [
      "homepageSummary",
      "aboutStory",
      "servicesDescription",
      "testimonials",
      "brandImages",
      "blogSection",
    ],
    sect4header: "Website Features & Functionality",
    sect4fields: [
      "desiredFeatures",
      "ecommerceNeeds",
      "integrations",
      "domainHosting",
      "maintenancePlan",
    ],
    sect5header: "Technical & Marketing Considerations",
    sect5fields: ["analyticsTracking", "seoKeywords", "additionalNotes"],

    btntext: "Let’s get started!",
    btnicon: "material-symbols:rocket-launch-outline",
    success: "Your information has been sent! We'll get to work immediately.",
  },
  {
    id: 4,
    formtitle: "We want to hear from you",
    formintro:
      "have you experienced a service form us? Tell us about your experience!",

    formid: "feedbackform",
    formname: "Acrylic Web Studios Feedback Form",
    sect1fields: ["Name", "Email", "TellUs", "EBI"],
    name: "",
    btntext: "Send",
    btnicon: "mynaui:send-solid",
    success: "Thank you for your feedback",
  },
  {
    id: 5,
    formtitle: "Let's get you on our calendar",
    formid: "calendarform",
    formname: "Acrylic Web Studios Booking Form",
    sect1cap: "Tell us a bit about yourself",
    sect1fields: ["Name", "OrganisationName", "Email", "Message"],

    btntext: "Let’s go!",
    btnicon: "material-symbols:rocket-launch-outline",
    success: "Thanks, we'll get back to you with a meeting time soon.",
  },
  {
    id: 6,
    formid: "mailinglist",
    formname: "Acrylic Web Studios Mailing List Form",
    formtitle: "Stay in the loop",
    formintro:
      "Sign up to our mailing list to be the first to know about new deals, new projects and more",
    sect1fields: ["Name", "Email"],
    btntext: "Sign up!",
    confirmationtxt: "Great, you're on the list!",
  },
  {
    id: 7,
    formid: "landingpageform",
    formname: "Acrylic Web Studios LandingPage Form",
    sect1fields: ["Name", "Email", "LandingPageMessage"],
    name: "",
    btntext: "Let’s land this page!",
    btnicon: "bxs:plane-land",
    success:
      "Your message has been sent! We will be in touch as soon as possible.",
  },
];
